<template>
    <main>
        <h1 class="text-green">{{this.dat.Title}}</h1>
        <h3>Descarga aquí tu {{this.dat.Title}} de una forma segura y rápida.</h3>
        <form>
            <FormItem 
                      v-for="input in this.dat.Inputs"
                      :key="input.Id"
                      :id="input.Id"
                      :label="input.Label"
                      v-model="input.Value"
                      :type="input.Type"
            ></FormItem>
            <div class="form-footer">
                <div v-if="this.dat.Title === 'Planilla Automática' || this.dat.Title === 'Certificado de Cesantías'" class="center" >
                    <div v-if="emptyData" style="
                        position: fixed;
                        width: 100% !important;
                        height: 6em !important;
                        margin: auto;
                        background-color: #ffffffa3;                        
                    "></div>

                    <p v-if="this.$flagTyCPila">
                        <span v-if="VisibleTyC" style="font-size: 1.9vh !important;">
                            <input type="checkbox" v-model="CheckTyC" />
                            He leído y acepto los
                            <a href="#" @click.prevent="descargarArchivo(VersionTyC)"><strong style="color: #007a5e;font-size: 1.8vh">Términos y Condiciones</strong></a>
                        </span><br>
                        <span v-if="VisibleTDP" style="font-size: 1.9vh !important;">
                            <input type="checkbox" v-model="CheckTDP" />
                            He leído y autorizo el
                            <a href="#" @click.prevent="descargarArchivo(VersionTDP)"><strong style="color: #007a5e;font-size: 1.8vh">Tratamiento de Datos Personales</strong></a>
                        </span><br>                        
                    </p>
                    <div v-if="this.$flagTyCDEL">
                        <div v-if="VisibleTDPDEL" style="display:flex; justify-content: center;">
                            <span class="tooltip" style="font-size: 1.9vh !important;" >
                                He leído y autorizo el
                                <a href="#" @click.prevent="descargarArchivo(VersionTDPDEL)"><strong style="color: #007a5e;font-size: 1.8vh">Tratamiento de Datos Personales</strong></a> para Datos en Línea
                                <span class="tooltiptext">El servicio que te permite gestionar el acceso a tu información de seguridad social sin papeleo y sin compartir tu información de contacto.</span>
                            </span>
                            <label style="font-size: 1.9vh !important; padding-left: 10px; padding-top: 5px;">Sí <input type="radio" :value="true" v-model="CheckTDPDEL" /></label>
                            <span>   </span>
                            <label style="font-size: 1.8vh !important; padding-left: 10px;  padding-top: 5px;">No <input type="radio" :value="false" v-model="CheckTDPDEL"/></label>
                        </div>
                    </div>
                </div>
                
                <div class="center">
                    <div v-if="emptyData" style="
                        position: fixed;
                        width: 100% !important;
                        height: 6em !important;
                        margin: auto;
                        background-color: #ffffffa3;
                    "></div>
                    <vue-recaptcha ref="recaptcha" v-if="this.$useCaptcha" :loadRecaptchaScript="true" :sitekey="this.$keyCaptcha" v-on:verify="captchaVerify"></vue-recaptcha>
                </div>
                <Btn 
                     action="submit"
                     type="green"
                     :disabled="submitDisabled || emptyData || !CheckTDP || !CheckTyC"
                     @click.prevent="submit"
                >{{sumbitText}}</Btn>
            </div>
        </form>
        <Spinner v-if="loading" type="modern"></Spinner>
    </main>
</template>

<script>
    import api from "../api/reports";
    import Btn from "../components/UIElements/Btn";
    import Spinner from "../components/UIElements/Spinner";
    import FormItem from "../components/UIElements/Form/FormItem";
    import VueRecaptcha from 'vue-recaptcha';
    import apiTyC from "../api/TyC";
    import apiUtils from "../api/utils";
    import encryption from "../utils/encryption"

    export default {
        name: "FormReport",
        components: { Btn, FormItem, Spinner, VueRecaptcha },
        data() {
            return {
                emptyData: true,
                loading: false,

                VersionTyC: "",
                VersionTDP: "",
                VisibleTyC: false,
                VisibleTDP: false,
                VisibleTDPDEL: false,
                VersionTDPDEL: "",
                CheckTyC: false,
                CheckTDP: false,
                CheckTDPDEL: true,

                datTyC: {
                    Title: "Reporte",
                    Inputs: [],
                    FileName: ""
                },

                datTyCDEL: {
                    Title: "Reporte",
                    Inputs: [],
                    FileName: ""
                },

                datInfoAportante: {
                    Title: "Reporte",
                    Inputs: [],
                    FileName: ""
                },

                dat: {
                    Title: "Reporte",
                    Inputs: [],
                    FileName: ""
                },
                submitDisabled: true,
                sumbitText: "Descargar",
                token: {},
                id: "",

            };
        },
        async created() {
            await this.getData(this.$route.params.id);
        },
        methods: {
            captchaVerify (response){
                this.submitDisabled = false;
                this.token = response;
            },
            btnEnable (){

            },
            async getData(id) {
                this.loading = true;
                this.id = id;

                try {
                    var resp = await api.get(this, id);
                    
                    if (!resp.error) {
                        this.dat = resp;
                        this.emptyData = false;
                        if (!this.$useCaptcha){
                            this.submitDisabled = false;
                        }
                    }

                    if (this.dat.Title === "Planilla Automática")
                    {
                        if (this.$flagTyCPila) {

                            var bodyConsulta = {
                                producto: this.$idProductoPILA,
                                idAportante: resp.Valor_Relacion
                            };

                            const inputs = await this.consultarDocumentosAprobados(bodyConsulta, apiTyC);

                            if (inputs) {
                                this.VersionTDP = inputs && inputs[0] ? inputs[0].VersionTDP : 0;
                                this.VersionTyC = inputs && inputs[0] ? inputs[0].VersionTyC : 0;
                                this.VisibleTyC = inputs && inputs[0] && !inputs[0].Aprobo && this.VersionTyC !== 0;
                                this.VisibleTDP = inputs && inputs[0] && !inputs[0].Aprobo && this.VersionTyC == 0;

                                if (inputs.length > 1 && !inputs[1].Aprobo) {
                                    this.VisibleTDP = true;
                                }

                                this.CheckTyC = !this.VisibleTyC;
                                this.CheckTDP = !this.VisibleTDP;
                            } else {
                                this.CheckTyC = true;
                                this.CheckTDP = true;
                            }
                        }else {
                            this.CheckTyC = true;
                            this.CheckTDP = true;
                        }

                        if (this.$flagTyCDEL) {

                            var bodyConsultaTDPDEL = {
                                producto: this.$idProductoDEL,
                                idAportante: resp.Valor_Relacion
                            };

                            const inputsDEL = await this.consultarDocumentosAprobados(bodyConsultaTDPDEL, apiTyC);
                            if (inputsDEL && inputsDEL[0]) {
                                this.VersionTDPDEL = inputsDEL[0].VersionTDP ? inputsDEL[0].VersionTDP : 0;
                                this.VisibleTDPDEL = inputsDEL[0].Aprobo ? false : true;
                            } else {
                                this.VersionTDPDEL = 0;
                                this.VisibleTDPDEL = false;
                            }
                        }
                    }
                    else if(this.dat.Title === "Certificado de Cesantías"){
                        if (this.$flagTyCDEL) {
                            this.$flagTyCPila = false;

                            let bodyConsultaCTDPDEL = {
                                producto: this.$idProductoDEL,
                                idAportante: "",
                                tipoIdentificacion: resp.Data.Data.certificadoCesantias.TipoIdentificacionEmpleado,
                                numeroIdentificacion: resp.Data.Data.certificadoCesantias.NumeroIdentificacionEmpleado
                            };

                            const inputsDEL = await this.consultarDocumentosAprobados(bodyConsultaCTDPDEL, apiTyC);
                            if (inputsDEL && inputsDEL[0]) {
                                this.VersionTDPDEL = inputsDEL[0].VersionTDP ? inputsDEL[0].VersionTDP : 0;
                                this.VisibleTDPDEL = inputsDEL[0].Aprobo ? false : true;
                            } else {
                                this.VersionTDPDEL = 0;
                                this.VisibleTDPDEL = false;
                            }
                            this.CheckTyC = true;
                            this.CheckTDP = true;
                        }
                        else{
                            this.CheckTyC = true;
                            this.CheckTDP = true;
                        }
                    }
                    else{
                        this.CheckTyC = true;
                        this.CheckTDP = true;
                    }
                } catch (e) {
                    this.$alert("Ocurrió un error al intentar consultar tu archivo");
                } finally {
                    this.loading = false;
                }
                return true;
            },
            async consultarDocumentosAprobados(body, api){
                try {
                    const publicKey = await apiUtils.obtenerPublicKey(this);
                    const encryptedPayload = await encryption.encryptWithPublicKey(body, publicKey);
                    
                    const respuesta = await api.consultarDocumentosAprobados(this, encryptedPayload, this.$idProductoPILA);

                    if (!respuesta.error && respuesta.Data && Array.isArray(respuesta.Data.Inputs) && respuesta.Data.Inputs.length > 0) {
                        return respuesta.Data.Inputs;
                    }
                    return null;
                } catch (error) {
                    return null;
                }
            },
            async guardarAprobaciones(origen){
                try {
                    var bodyAprobacion = [];
                    if (this.$flagTyCDEL & this.VisibleTDPDEL)
                    {
                        var tipoAprobacion = 0;
                        if(this.CheckTDPDEL){
                            tipoAprobacion = 1;
                        }
                        
                        let TIdEmp = this.dat.Data.Data.certificadoCesantias !== undefined ? this.dat.Data.Data.certificadoCesantias.TipoIdentificacionEmpleado : '';
                        let NIdEmp = this.dat.Data.Data.certificadoCesantias !== undefined ? this.dat.Data.Data.certificadoCesantias.NumeroIdentificacionEmpleado : '';

                        bodyAprobacion.push({
                            IdV: this.VersionTDPDEL,
                            Prod: this.$idProductoDEL,
                            TA: tipoAprobacion,
                            IdAp: this.dat.Valor_Relacion,
                            TIdEmp: TIdEmp,
                            NIdEmp: NIdEmp
                        });
                    }

                    if (this.$flagTyCPila){
                        if(this.VisibleTyC){
                            
                            bodyAprobacion.push({
                                IdV: this.VersionTyC,
                                Prod: this.$idProductoPILA,
                                TA: 1,
                                IdAp: this.dat.Valor_Relacion
                            });
                        }
                        if(this.VisibleTDP)
                        {
                            bodyAprobacion.push({
                                IdV: this.VersionTDP,
                                Prod: this.$idProductoPILA,
                                TA: 1,
                                IdAp: this.dat.Valor_Relacion
                            });
                        }
                    }
                    const publicKey = await apiUtils.obtenerPublicKey(this);
                    const encryptedPayload = await encryption.encryptWithPublicKey(bodyAprobacion, publicKey);
                    if (origen === "Planilla Automática"){
                        await apiTyC.aprobarDocumentosLegalesAutomaticas(this, encryptedPayload);
                    }else{
                        await apiTyC.aprobarDocumentosLegalesCesantias(this, encryptedPayload);
                    }

              } catch (e) {
                  this.$alert(
                      "Ocurrió un error al aprobar los documentos "
                  ).then(() => {
                      document.location = window.location.protocol + "//" + window.location.host + "/index.html#/";
                  });
              } finally {
                  this.loading = false;
              }
            },
            base64ToArrayBufferMultiple(base64) {
                var binaryString = window.atob(base64.join(""));
                var binaryLen = binaryString.length;
                var bytes = new Uint8Array(binaryLen);
                for (var i = 0; i < binaryLen; i++) {
                    var ascii = binaryString.charCodeAt(i);
                    bytes[i] = ascii;
                }
                return bytes;
            },
            base64ToArrayBuffer(base64) {
                var binaryString = window.atob(base64);
                var binaryLen = binaryString.length;
                var bytes = new Uint8Array(binaryLen);
                for (var i = 0; i < binaryLen; i++) {
                    var ascii = binaryString.charCodeAt(i);
                    bytes[i] = ascii;
                }
                return bytes;
            },
            saveByteArray(reportName, byte) {
                var blob = new Blob([byte], { type: this.dat.FileType });
                var link = document.createElement("a");
                link.href = window.URL.createObjectURL(blob);
                link.download = reportName;
                link.click();
            },
            async submit() {
                this.loading = true;
                //this.token = await this.$recaptcha("download");
                
                if ((this.dat.Title === "Planilla Automática" || this.dat.Title === "Certificado de Cesantías") && (this.VisibleTDP || this.VisibleTyC || this.VisibleTDPDEL ))
                {
                    await this.guardarAprobaciones(this.dat.Title);
                }

                var dat = {
                    id: this.id,
                    recaptchaToken: this.token,
                    data: this.dat.Inputs
                };
                try {
                    var file = await api.download(this, dat);
                    if (!file.error) {
                        if (file.Reporte !== null || file.ReportePorPartes !== null) {
                            var pdf;

                            if (file.Reporte !== null) {
                                pdf = this.base64ToArrayBuffer(file.Reporte);
                            }
                            else if (file.ReportePorPartes !== null) {
                                pdf = this.base64ToArrayBufferMultiple(file.ReportePorPartes);
                            }

                            if (pdf !== null) {
                                this.saveByteArray(this.dat.FileName, pdf);
                            } else {
                                this.$alert(
                                    "Ocurrió un error al intentar descargar tu " + this.dat.Title
                                );
                            }
                        } else {
                            this.$alert(
                                "Ocurrió un error al intentar descargar tu " + this.dat.Title
                            );
                        }
                    }
                } catch (e) {
                    this.$alert(
                        "Ocurrió un error al intentar descargar tu " + this.dat.Title
                    );
                } finally {
                    this.loading = false;
                    this.$refs.recaptcha.reset();
                    this.submitDisabled = true;
                }
            },
            async descargarArchivo(IdVersion){
                try {
                    const response = await apiTyC.downloadVersion(this, IdVersion);
                    const documento = response["<ContenidoArchivo>k__BackingField"]
                    const url = `data:application/pdf;base64,${documento}`;
                    const link = document.createElement("a");
                    link.href = url;
                    link.setAttribute("download", response["<NombreArchivo>k__BackingField"]);
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                } catch (e) {
                    this.$alert(
                        "Ocurrió un error al descargar el archivo "
                    ).then(() => {
                        document.location = window.location.protocol + "//" + window.location.host + "/index.html#/";
                    });
                }
            }
        }
    };
</script>

<style>

    form {
        margin: 1em auto;
    }

        form .form-footer {
            width: 100%;
            box-sizing: border-box;
            float: left;
            margin-bottom: 10px;
        }

        form .form-item {
            width: 100%;
            box-sizing: border-box;
            float: left;
            margin: 1em auto;
        }

        form label {
            display: block;
            padding: 0.5em 0;
            color: #777;
        }

        form input[type=text], form input[type=number], form input[type=email], form textarea {
            outline: none;
            text-align: center;
            border-width: 0px 0px 1px;
            border-top-style: initial;
            border-right-style: initial;
            border-bottom-style: solid;
            border-left-style: initial;
            border-top-color: initial;
            border-right-color: initial;
            border-bottom-color: rgb(204, 204, 204);
            border-left-color: initial;
            border-image: initial;
            background-color: white;
            font: inherit;
            display: block;
            width: 20em;
            box-sizing: border-box;
            color: #777;
            font-weight: 600;
            margin: auto;
        }

    .form-footer {
        margin-top: 1.5em;
    }

    @media screen and (max-width: 320px) {
        form input[type=text], form input[type=number], form input[type=email] {
            width: 18em;
        }
    }
    .tooltip {
        position: relative;
        display: inline-block;
        border-bottom: 1px dotted black;
    }
        
    .tooltip .tooltiptext {
        visibility: hidden;
        width: 300px;
        background-color: rgb(95, 90, 90);
        color: rgb(255, 255, 255);
        text-align: center;
        border-radius: 6px;
        padding: 5px 0;
        
        /* Position the tooltip */
        position: absolute;
        z-index: 1;
    }
    
    .tooltip:hover .tooltiptext {
        visibility: visible;
        width: 400px;
        bottom: 100%;
        left: 20%;
        margin-left: -60px;
    }
</style>
